export default __webpack_public_path__ + "static/media/header-xl.9f066e35.png";